(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/api-jokerbet.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/api-jokerbet.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class JokerBet {
  constructor(_ref) {
    let {
      wagerModel,
      day
    } = _ref;
    this.wagerModel = wagerModel;
    this.day = day;
    return new svs.tur.payment.api.jupiter.request.Bet({
      productId: this.productId,
      betAmountSalesGroup1: this.betAmountSalesGroup1,
      betAmountSalesGroup2: this.betAmountSalesGroup2,
      betProperties: this.betProperties,
      drawNum: this.drawNum,
      numDraws: this.numDraws,
      rowPriceMulti: this.rowPriceMulti,
      jokerBoards: this.jokerBoards
    });
  }
  get betAmountSalesGroup1() {
    return svs.utils.format.CurrencyAsJupiterString(this.wagerModel.get('jokerPrice') * parseInt(this.wagerModel.get('drawCount'), 10));
  }
  get betAmountSalesGroup2() {
    return '0,00';
  }
  get betProperties() {
    const betProperties = [];
    if (this.wagerModel.get('prolongedBet')) {
      const wager = this.wagerModel.toObject();
      const isProlonged = svs.numbergames.game_model.utils.prolongation.isProlongedJoker(_objectSpread(_objectSpread({}, wager), {}, {
        jokerItsId: this.productId
      }));
      if (isProlonged) {
        betProperties.push('PROLONGATION');
      }
    }
    if (this.wagerModel.get('isSyndicate')) betProperties.push('BOLAG');
    return betProperties;
  }
  get drawNum() {
    const product = this.day || this.wagerModel.get('productId');
    if (svs.numbergames.productMapping.isLotto(product)) {
      if (svs.numbergames.game.draw[product].jokerDrawNumber) return svs.numbergames.game.draw[product].jokerDrawNumber;
      return svs.numbergames.game.draw[product].nextJokerDrawNumber;
    }
    return svs.numbergames.game.draw.jokerDrawNumber;
  }
  get numDraws() {
    return parseInt(this.wagerModel.get('drawCount'), 10);
  }
  get productId() {
    const product = this.day || this.wagerModel.get('productId');
    return svs.numbergames.productMapping.getJokerProductId(product);
  }
  get rowPriceMulti() {
    return this.wagerModel.get('jokerPrice') / 10;
  }
  get boardProps() {
    const manualNumbers = this.wagerModel.get('jokerRow').filter(numObj => numObj && numObj.manual);
    if (manualNumbers.length === 0) return ['QUICKPICK'];
    if (manualNumbers.length === this.wagerModel.getJokerRowAsArray().length) return [];
    return ['PARTIALQP'];
  }
  get jokerBoards() {
    return [{
      boardData: this.wagerModel.getJokerRowAsArray(),
      numSelections: 7,
      participation: 0,
      rowPriceMulti: 1,
      systemType: ['SROW'],
      boardProps: this.boardProps
    }];
  }
}
svs.numbergames.game_model.utils.API_JokerBet = JokerBet;

 })(window);